import React from 'react';

const PortfolioViewer = () => {
  return (
    <>
    <div style={{ width: '100%', height: '100vh' }}>        
      <iframe
        src="/assets/cv/Portfolio.pdf"
        width="100%"
        height="100%"
        title="Portfolio PDF"
      ></iframe>
    </div>
    </>
  );
};

export default PortfolioViewer;